import * as React from "react";
import { Button, makeStyles } from "@material-ui/core";
import { BsCheck, BsLockFill, BsPencil } from "react-icons/bs";
import UserManager from "common/userManager";
import StoreKeys from "common/storeKeys";
import { connect } from "common/connect";
import ViewToggle from "common/components/ViewToggle/ViewToggle";
import BackToMyPicks from "common/components/EventControls/BackToMyPicks";
import {
	CONTROL_HEIGHT_DESKTOP,
	useEventControlStyles,
} from "common/components/EventControls/eventControlStyles";

const propKeys = {
	bracketUser: StoreKeys.EVENT.BRACKET_USER,
	hasBracket: StoreKeys.EVENT.HAS_BRACKET,
	eventData: StoreKeys.EVENT.EVENTDATA,
	stageIndex: StoreKeys.EVENT.STAGE_INDEX,
	submittedStageIds: StoreKeys.EVENT.USER.SUBMITTED_STAGE_IDS,
};

const useStyles = makeStyles((theme) => {
	const desktop = theme.breakpoints.up("md");

	return {
		eventFooter: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			marginTop: 8,
			paddingBottom: 10,
		},
		row: {
			display: "flex",
			flexDirection: "row",
			flexWrap: "wrap",
			alignItems: "center",
			justifyContent: "center",
			gap: "8px 22px",
			width: "100%",
			userSelect: "none",

			[desktop]: {
				gap: "8px 24px",
			},
		},
		toggle: {
			[desktop]: {
				height: CONTROL_HEIGHT_DESKTOP,

				"& button": {
					fontSize: 11,
					padding: "0 18px",
				},
			},
		},
	};
});

export function EventFooterC(props) {
	const {
		bracketUser,
		hasBracket,
		eventData,
		stageIndex,
		submittedStageIds,
		width,
		onEdit,
		showingOfficialResults,
		showOfficialResults,
		picksLocked,
		isStageOpen,
	} = props;
	const styles = useStyles();
	const controls = useEventControlStyles();

	const isCurrentUser =
		bracketUser == null || bracketUser.userId === UserManager.getUserId();

	const eventStage = eventData?.eventStages?.[stageIndex];
	const hasPicksForStage =
		!!eventStage && (submittedStageIds ?? []).includes(eventStage.id);

	const onSelectView = (id) => {
		showOfficialResults(id === "results");
	};

	const viewSwitch = (
		<ViewToggle
			className={styles.toggle}
			value={showingOfficialResults ? "results" : "picks"}
			items={[
				{ id: "picks", text: isCurrentUser ? "My picks" : "Their picks" },
				{ id: "results", text: "Results" },
			]}
			onChange={onSelectView}
		/>
	);

	return (
		<div style={{ width: width ?? 400 }} className={styles.eventFooter}>
			<div className={styles.row}>
				{isCurrentUser && (
					<>
						{hasPicksForStage && (
							<span className={controls.status + " " + controls.submitted}>
								<BsCheck />
								<span className={controls.statusLabel}>Submitted</span>
							</span>
						)}
						{!picksLocked && (
							<Button
								className={controls.action}
								startIcon={<BsPencil />}
								onClick={() => {
									if (onEdit) {
										onEdit();
									} else {
										console.error(
											"onEdit callback was not provided to EventFooter Component!"
										);
									}
								}}
							>
								{hasPicksForStage ? "Edit your picks" : "Make your picks"}
							</Button>
						)}
						{picksLocked && (
							<span className={controls.status + " " + controls.lockedChip}>
								<BsLockFill />
								<span className={controls.statusLabel}>
									{isStageOpen ? "Picks locked" : "Stage closed"}
								</span>
							</span>
						)}
						{(hasPicksForStage || picksLocked) && viewSwitch}
					</>
				)}
				{!isCurrentUser && (
					<>
						<span className={controls.status}>
							<span className={controls.statusLabel}>
								{bracketUser.username + "'s picks"}
							</span>
						</span>
						{(!picksLocked || hasBracket) && <BackToMyPicks />}
						{/* results stay hidden until picks lock */}
						{picksLocked && viewSwitch}
					</>
				)}
			</div>
		</div>
	);
}

export default function EventFooter(props) {
	return connect(<EventFooterC />, propKeys, props);
}
